import { Howl, Howler } from 'howler'

const AUDIO = {
  'bacteria-bounce-1': [ require('../assets/sfx/bacteria-bounce-1.mp3') ],
  'bacteria-bounce-2': [ require('../assets/sfx/bacteria-bounce-2.mp3') ],
  'bacteria-buzzing': [ require('../assets/sfx/bacteria-buzzing.mp3') ],
  'outside-inside': [ require('../assets/sfx/outside-inside.mp3') ],
  'outside-world': [ require('../assets/sfx/outside-world.mp3') ],
  'product-reveal': [ require('../assets/sfx/product-reveal.mp3') ],
  'smile-1': [ require('../assets/sfx/smile-1.mp3') ],
  'smile-2': [ require('../assets/sfx/smile-2.mp3') ],
  'smile-3': [ require('../assets/sfx/smile-3.mp3') ],
  'smile-4': [ require('../assets/sfx/smile-4.mp3') ],
  'smile-5': [ require('../assets/sfx/smile-5.mp3') ],
  'tv-switch': [ require('../assets/sfx/tv-switch.mp3') ],
  'underwater': [ require('../assets/sfx/underwater.mp3') ],
  'whoosh': [ require('../assets/sfx/whoosh.mp3') ],
  'whoosh-2': [ require('../assets/sfx/whoosh-2.mp3') ],
  'wonderful-world': [ require('../assets/sfx/wonderful-world.mp3') ],
}

class AudioManager {
  constructor () {
    this.playBuffer = []
    Object.keys(AUDIO).forEach(key => new Howl({ src: AUDIO[key], preload: true }))
    Howler.mute(true)
  }

  unmute () {
    Howler.mute(false)
  }

  mute () {
    Howler.mute(true)
  }

  playSound (key, vol = 0.5, opts = {}) {
    if (AUDIO[key]) {
      let sound = new Howl({
        src: AUDIO[key],
        volume: vol,
        ...opts,
      })
      sound.play()
      this.playBuffer.push({ key, sound })
    } else {
      console.log(`Audio Sound for ${key} is invalid!`)
    }
  }

  playTrack (key, vol = 0.05, opts = {}) {
    if (AUDIO[key]) {
      const sound = new Howl({
        src: AUDIO[key],
        loop: true,
        autoplay: true,
        volume: vol,
        ...opts,
      })
      this.playBuffer.push({ key, sound })
    } else {
      console.log(`Audio Track for ${key} is invalid!`)
    }
  }

  stop (key) {
    this.playBuffer.filter(o => o.key === key).forEach(o => {
      o.sound.fade(o.sound.volume(), 0, 500)
    })
    this.playBuffer = this.playBuffer.filter(o => o.key !== key)
  }
}

export default new AudioManager()
